import "./AcoeNote1.css";
import { useState } from "react";
import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import Cookies from "js-cookie";
import axios from "../../axios.jsx";
import RotateLeftIcon from "@mui/icons-material/RotateLeft";

function VcNote2() {

  const [scholarDetails, setScholarDetails] = useState(null);
  const [adjudicatorDetails, setAdjudicatorDetails] = useState(null);
  const [approve, setApprove] = useState(false);
  const [appointed, setAppointed] = useState(-1);
  const [mode, setMode] = useState("");

  const loc = useLocation();
  setInterval(() => {
    if (!Cookies.get("userInfo")) {
      logout();
    }
  }, 1000);
  useEffect(() => {
    if (Cookies.get("username") != loc.state.officer) {
      alert("unauthorized to this page")
      logout();
    }
    var data = {
      scholarId: loc.state.id,
      note: loc.state.note
    }
    axios
      .post("/api/get-bospanel-officer", data)
      .then((resData) => {
        setScholarDetails(resData.data.panel_data);
        setAdjudicatorDetails(resData.data.adjuticators_data);
      })
      .catch((e) => {
        alert("can't find bos details");
      });

  }, []);

  async function handleSubmit() {
    let reqData = {
      scholarId: loc.state.id,
      status: approve ? "APPROVED" : "REJECTED",
      designation: Cookies.get("username"),
      note: loc.state.note,
      appointed:appointed,
      mode:mode
    }
    try {
      const resData = await axios.post("/api/update-bospanel", reqData);
      if (resData.status === 200) {
        console.log(resData.data["file-name"]);
      } else {
        console.log(resData);
      }
    } catch (e) {
      console.log(e);
    }
    alert("success");
  }

  const handleApproveOrReject = (e) => {
    if (e.target.value === "true") {
      document.getElementById("approve").checked = true;
      document.getElementById("reject").checked = false;
      setApprove(true);
    } else {
      document.getElementById("approve").checked = false;
      document.getElementById("reject").checked = true;
      setApprove(false);
    }
  };



  return (
    <>
      {(scholarDetails === null || adjudicatorDetails === null) ? (
        <center>
          <RotateLeftIcon
            sx={{
              fontSize: "3rem",
              margin: "0 auto",
              color: "rgba(0,0,0,0.6)",
              animation: "spin 1s linear infinite",
              "@keyframes spin": {
                "0%": {
                  transform: "rotate(360deg)",
                },
                "100%": {
                  transform: "rotate(0deg)",
                },
              },
            }}
          />{" "}
          Loading Details
        </center>
      ) : (
        <>
          <br />
          <br />
          <center>
            <form enctype="multipart/form-data">
              <div className="whole-body">
                <br />
                <h1>KAKATIYA UNIVERSITY</h1>
                <br />
                <div className="header">File-No. Branch(E1) Unit</div>
                <hr />
                <div font-size="15">
                  <table className="header-table">
                    <tr>
                      <th>SUBJECT :</th>
                      <td>
                        <b> {scholarDetails.subject} </b>-Ph.D.thesis submitted by{" "}
                        <b>Mr/Ms. {scholarDetails.name_of_scholar} -</b> Appointment of{" "}
                        <b>
                          <i>Three Examiners</i>
                        </b>{" "}
                        for Evaluation-Reg.
                      </td>
                    </tr>
                  </table>
                </div>
                <hr />
                <div className="main-content">
                  In compliance with the Approval of the Vice-Chancellor at para-06,
                  a letter was issued by this office vide letter No.
                  {scholarDetails.letter_no1}
                  /E1/Ph.D/KU/
                  {scholarDetails.letter_no2} , dated{" "}
                  {scholarDetails.letter_date}

                  <br />
                  <br />
                  The Ph.D Reports on the Thesis Submitted by{" "}
                  <b> Mr./Ms. {scholarDetails.name_of_scholar} </b>in<b> {scholarDetails.subject}</b> have been received
                  from the following Examinars:
                </div>
                <div className="examinars">
                  <b>Three Examiners</b> may please be appointed from the following:
                  <br />
                  <br />
                  <b>
                    <u>One Examiner from S.No.1 to 3</u>
                  </b>
                  <br />
                  <ol>
                    {adjudicatorDetails.map((obj) => {
                      return (
                        <li key={obj.mobile}>
                          {obj.name}, {obj.name_of_university}, <b> {obj.state}</b>.
                        </li>
                      )
                    })}
                  </ol>
                </div>
                <div className="main-content">
                  Kindly submit the Ph.D reports at flag <br />
                  <br />
                  <b>
                    'A':
                    <a href={axios.defaults.baseURL + "api" + scholarDetails.report_a} target="_blank">
                      <button type="button" className="btn btn-secondary">
                        View File
                      </button>
                    </a>
                    'B':
                    <a href={axios.defaults.baseURL + "api" + scholarDetails.report_b} target="_blank">
                      <button type="button" className="btn btn-secondary">
                        View File
                      </button>
                    </a>
                    'C':
                    <a href={axios.defaults.baseURL + "api" + scholarDetails.report_c} target="_blank">
                      <button type="button" className="btn btn-secondary">
                        View File
                      </button>
                    </a>
                  </b>
                  <br />
                  <br />
                  The <b>Three Examinars</b> have recommended for the Award of Ph.D.
                  Degree to the Candidate after Conducting the Open Viva-Voce.
                  <br />
                  <br />
                  Hence, if agreed, <b>One Examinar</b> may be appointed from the
                  above of three Examinars to conduct the open viva-voce of the
                  candidate as per the Ph.d.New Rules(8) ix.1 of Kakatiya
                  University.
                  <br />
                  <br />
                  Submitted for Approval
                  <br />
                  <br />
                  Submitting for appointing One of the Examiners
                </div>
                <br />
                <center>
                  <div font-size="15">
                    <b>
                      Appointed S.No{" "}
                      <input
                        type="number"
                        onChange={(e)=>{setAppointed(e.target.value)}}
                        min="1"
                        max="3"
                        required
                      />{" "}
                      Examinar for Viva-Voce{" "}
                      <select 
                      onChange={(e)=>setMode(e.target.value)}
                      required>
                        <option value="Online">Online</option>
                        <option value="Offline">Offline</option>
                        <option value="Online/Offline">Online/Offline</option>
                      </select>{" "}
                      mode.
                    </b>
                    <br />
                    <br />
                  </div>
                </center>
                <div className="footer">
                  <div>
                    <input
                      onClick={handleApproveOrReject.bind(this)}
                      type="radio"
                      id="approve"
                      defaultChecked={approve ? true : false}
                      style={{ marginRight: 10 }}
                      value="true"
                      required
                    />
                    <label>Approve</label>
                    <input
                      onClick={handleApproveOrReject.bind(this)}
                      type="radio"
                      id="reject"
                      defaultChecked={!approve ? true : false}
                      style={{ marginLeft: 10, marginRight: 10 }}
                      required
                    />
                    <label>Reject</label>
                  </div>
                </div>
                <br />
                <br />
                <br />
                <div>
                  <input onClick={handleSubmit} className="btn btn-secondary" required />
                </div>
                <br />
                <br />
                <br />
              </div>
            </form>
          </center>
          <br />
          <br />
        </>
      )}</>
  );
}
export default VcNote2;


function logout() {
  window.localStorage.clear();
  Cookies.remove("userInfo");
  Cookies.remove("username");
  window.location.href = "/officers-login";
}